var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-table-cell-date",domProps:{"textContent":_vm._s(_vm.dateFormatted)}})
}
var staticRenderFns = []

export { render, staticRenderFns }